export default __webpack_public_path__ + "static/media/Todos.fc2131bd.svg";